import { Editor } from "@tiptap/react";
import { Box, IconButton, Select, MenuItem } from "@mui/material";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { useState } from "react";
import { useEffect } from "react";

export function WordToolbar({ editor }: { editor: Editor | null }) {
   const [fontSize, setFontSize] = useState("12px");
   const [fontFamily, setFontFamily] = useState("Calibri");

  useEffect(() => {
    if (!editor) return;

    const updateFontSize = () => {
      const size = editor.getAttributes("textStyle").fontSize || "12px";
      setFontSize(size);
    };

    updateFontSize(); // initial

    editor.on("selectionUpdate", updateFontSize);
    editor.on("transaction", updateFontSize);

    return () => {
      editor.off("selectionUpdate", updateFontSize);
      editor.off("transaction", updateFontSize);
    };
  }, [editor]);
  useEffect(() => {
  if (!editor) return;

  const updateFontFamily = () => {
    const family =
      editor.getAttributes("textStyle").fontFamily || "Calibri";
    setFontFamily(family);
  };

  updateFontFamily(); // initial

  editor.on("selectionUpdate", updateFontFamily);
  editor.on("transaction", updateFontFamily);

  return () => {
    editor.off("selectionUpdate", updateFontFamily);
    editor.off("transaction", updateFontFamily);
  };
}, [editor]);

  if (!editor) return null;

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        editor
          .chain()
          .focus()
          .setImage({
            src: reader.result as string,
            width: 75, // 👈 HTML width attribute
          })
          .run();
      };
      reader.readAsDataURL(file);
    };

    input.click();
  };
 

  const setLink = () => {
    const previousUrl = editor.getAttributes("link").href;
    const url = window.prompt("Enter link URL", previousUrl);

    if (url === null) return;

    if (url === "") {
      editor.chain().focus().unsetLink().run();
      return;
    }

    editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
  };

  return (
   <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
  px:1,
    mb: 1,

    backgroundColor: "#F9FAFB",
    border: "1px solid #D1D5DB",
    borderRadius: "8px",

    color: "#111827",

   
    overflowX: "auto",  
    overflowY: "hidden", 

    flexWrap: "nowrap",  
    whiteSpace: "nowrap",

    

    
    "& > *": {
      flexShrink: 0,
    },

    // scrollbar styling (optional)
    "&::-webkit-scrollbar": {
      height: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#D1D5DB",
      borderRadius: 10,
    },

    "& .MuiSvgIcon-root": {
      color: "#374151 !important",
    },

    "& .MuiIconButton-root:hover": {
      backgroundColor: "#E5E7EB",
    },
  }}
>
      {/* Font family */}
      <Select
        size="small"
       value={fontFamily}
  onChange={(e) => {
    const newFont = e.target.value;
    setFontFamily(newFont);

    editor
      .chain()
      .focus()
      .setFontFamily(newFont)
      .run();
  }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#FFFFFF",
              color: "#111827",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",

              "& .MuiMenuItem-root": {
                color: "#111827",
              },

              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#F3F4F6",
              },

              "& .Mui-selected": {
                backgroundColor: "#EEF2FF !important",
              },
            },
          },
        }}
        sx={{
          height: 30,
          width: 90,
          backgroundColor: "#FFFFFF",
          color: "#111827",

          fontFamily: editor.getAttributes("textStyle").fontFamily || "Calibri",

          /* Fix the actual border */
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9CA3AF",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4F46E5",
            borderWidth: "2px",
          },

          /* Fix dropdown icon */
          "& .MuiSvgIcon-root": {
            color: "#374151",
          },

          /* Prevent dark mode overrides */
          "& .MuiSelect-select": {
            color: "#111827",
          },
        }}
      >
        {/* Sans-serif */}
        <MenuItem value="Calibri" sx={{ fontFamily: "Calibri" }}>
          Calibri
        </MenuItem>
        <MenuItem value="Arial" sx={{ fontFamily: "Arial" }}>
          Arial
        </MenuItem>
        <MenuItem value="Helvetica" sx={{ fontFamily: "Helvetica" }}>
          Helvetica
        </MenuItem>
        <MenuItem value="Verdana" sx={{ fontFamily: "Verdana" }}>
          Verdana
        </MenuItem>

        {/* Serif */}
        <MenuItem
          value="Times New Roman"
          sx={{ fontFamily: "Times New Roman" }}
        >
          Times New Roman
        </MenuItem>
        <MenuItem value="Georgia" sx={{ fontFamily: "Georgia" }}>
          Georgia
        </MenuItem>

        {/* Monospace */}
        <MenuItem value="Courier New" sx={{ fontFamily: "Courier New" }}>
          Courier New
        </MenuItem>

        {/* Modern / Web-safe */}
        <MenuItem value="Trebuchet MS" sx={{ fontFamily: "Trebuchet MS" }}>
          Trebuchet MS
        </MenuItem>
        <MenuItem value="Tahoma" sx={{ fontFamily: "Tahoma" }}>
          Tahoma
        </MenuItem>
      </Select>

      {/* Font size */}
     
      <Select
        size="small"
        value={fontSize}
        onChange={(e) => {
          const newSize = e.target.value;
          setFontSize(newSize);

          editor
            .chain()
            .focus()
            .setMark("textStyle", { fontSize: newSize })
            .run();
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#FFFFFF",
              color: "#111827",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",

              "& .MuiMenuItem-root": {
                color: "#111827",
              },

              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#F3F4F6",
              },

              "& .Mui-selected": {
                backgroundColor: "#EEF2FF !important",
              },
            },
          },
        }}
        sx={{
          height: 30,
          minWidth: 60,
          backgroundColor: "#FFFFFF",
          color: "#111827",

          /* Fix real border */
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9CA3AF",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4F46E5",
            borderWidth: "2px",
          },

          /* Fix arrow icon */
          "& .MuiSvgIcon-root": {
            color: "#374151",
          },

          "& .MuiSelect-select": {
            color: "#111827",
          },
        }}
      >
        <MenuItem value="12px">12</MenuItem>
        <MenuItem value="14px">14</MenuItem>
        <MenuItem value="16px">16</MenuItem>
        <MenuItem value="18px">18</MenuItem>
        <MenuItem value="20px">20</MenuItem>
        <MenuItem value="24px">24</MenuItem>
        <MenuItem value="28px">28</MenuItem>
      </Select>

      <IconButton onClick={() => editor.chain().focus().toggleBold().run()}>
        <FormatBoldIcon />
      </IconButton>

      <IconButton onClick={() => editor.chain().focus().toggleItalic().run()}>
        <FormatItalicIcon />
      </IconButton>

      <IconButton
        onClick={() => editor.chain().focus().toggleUnderline().run()}
      >
        <FormatUnderlinedIcon />
      </IconButton>

      <input
        type="color"
        style={{
          height: 30,
          minWidth: 10,
          cursor: "pointer",
        }}
        onChange={(e) => editor?.chain().focus().setColor(e.target.value).run()}
      />
      <IconButton
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        color={editor.isActive("bulletList") ? "primary" : "default"}
      >
        <FormatListBulletedIcon />
      </IconButton>

      <IconButton
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        color={editor.isActive("orderedList") ? "primary" : "default"}
      >
        <FormatListNumberedIcon />
      </IconButton>

      <IconButton
        onClick={() => editor.chain().focus().setTextAlign("left").run()}
      >
        <FormatAlignLeftIcon />
      </IconButton>

      <IconButton
        onClick={() => editor.chain().focus().setTextAlign("center").run()}
      >
        <FormatAlignCenterIcon />
      </IconButton>

      <IconButton
        onClick={() => editor.chain().focus().setTextAlign("right").run()}
      >
        <FormatAlignRightIcon />
      </IconButton>

      {/* NEW: Image */}
      <IconButton onClick={addImage}>
        <ImageIcon />
      </IconButton>

      {/* NEW: Link */}
      <IconButton onClick={setLink}>
        <LinkIcon />
      </IconButton>
    </Box>
  );
}
